import { Link } from "gatsby";
import React from "react";

const Rewards = () => {
  return (
    <div className="bg-slate-200 py-16">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-10 md:mb-0 md:w-3/5">
            <h3 className="text-black font-bold text-xl mb-2">Rewards</h3>
            <p className="text-black text-xl">
              Qualifying account activity can unlock rewards that make your line
              of credit more flexible to pay back and more affordable to get
              money when you need it. For more information on{" "}
              <strong>Skip-a-Pay</strong> and <strong>Fee Saver</strong>{" "}
              rewards, visit the{" "}
              <Link className="text-blue-800 hover:underline" to="/rewards/">
                Line of Credit Rewards
              </Link>{" "}
              page.
            </p>
          </div>
          <img
            src="/svgs/laptop-dollar.svg"
            className="mx-auto sm:mx-0 sm:w-60 h-full"
            alt="Rewards"
          />
        </div>
      </div>
    </div>
  );
};

export default Rewards;
